import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
import { useEffect } from "react";

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    const valid = points.filter((p) => p.lat != null && p.lng != null);
    if (valid.length === 0) return;
    if (valid.length === 1) {
      map.setView([valid[0].lat, valid[0].lng], 14);
    } else {
      map.fitBounds(valid.map((p) => [p.lat, p.lng]), { padding: [40, 40], maxZoom: 15 });
    }
  }, [map, points]);
  return null;
}

const COLORS = {
  vendor: "#1E3F33",
  customer: "#E05A3D",
  driver: "#E05A3D",
};

export function OrderMap({ points = [], height = 320 }) {
  const valid = points.filter((p) => p.lat != null && p.lng != null);
  const center = valid[0] ? [valid[0].lat, valid[0].lng] : [-33.9321, 18.8602];
  return (
    <div className="overflow-hidden rounded-2xl border" style={{ height }} data-testid="order-map">
      <MapContainer center={center} zoom={13} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; OpenStreetMap contributors'
        />
        {valid.map((p, i) => (
          <CircleMarker
            key={i}
            center={[p.lat, p.lng]}
            radius={p.type === "driver" ? 9 : 8}
            pathOptions={{
              color: "#fff",
              weight: 2,
              fillColor: COLORS[p.type] || "#E05A3D",
              fillOpacity: 1,
            }}
          >
            {p.label && <Popup>{p.label}</Popup>}
          </CircleMarker>
        ))}
        <FitBounds points={valid} />
      </MapContainer>
    </div>
  );
}
